import moment from 'moment';

export const Competencia = (value) => {
  return value ? moment(value).format('MM/YYYY') : '-';
};

export const DataBR = (value) => {
  return value ? moment(value).format('DD/MM/YYYY') : '-';
};
